import type {
  BulkReviewSetOperationBlock,
} from '../../../services/bulkPricingReview/bulkPricingReview.types';

export type BulkJobRowLike = {
  setOperations?: BulkReviewSetOperationBlock[] | null;
};

/** Variant ID targeted by this row's first set-price operation, or undefined. */
export function getPrimaryVariantIdFromJobRow(row: BulkJobRowLike): string | undefined {
  return row.setOperations?.[0]?.setVariantPrice?.variantId;
}

/** All unique variant IDs across every setVariantPrice entry in this row. */
export function getAllVariantIdsFromJobRow(row: BulkJobRowLike): string[] {
  if (!row.setOperations) return [];
  const ids: string[] = [];
  for (const op of row.setOperations) {
    const id = op?.setVariantPrice?.variantId;
    if (id && !ids.includes(id)) ids.push(id);
  }
  return ids;
}

/** S3 directory segments that indicate a status-prefixed (non-pending) review key. */
const REVIEW_STATUS_SEGMENTS = ['archive', 'canceled', 'failed'];

/**
 * Extract the franchise code from a review's S3 key, handling both key shapes:
 * - Pending:  `moa-bulk-review/{FRANCHISE}/{file}`
 * - Archived/canceled/failed: `moa-bulk-review/{status}/{FRANCHISE}/{file}`
 */
export function extractFranchiseFromReviewKey(key: string): string {
  const parts = key.split('/');
  if (parts.length >= 3 && REVIEW_STATUS_SEGMENTS.includes(parts[1].toLowerCase())) {
    // Status is included in path, franchise code is at parts[2]
    return parts[2];
  }
  // Default case: franchise code is at parts[1] (pending files)
  return parts.length >= 2 ? parts[1] : '';
}
